import gameData from "./gameData";

export default function setupGameConfig(variantId) {
  const config = {
    subtitle: null,
    numOfLevels: 5, // the number of levels to play (5 is the original/default)
    denominationType: null, // null to allow the user to pick their own, otherwise one of the denominationTypes (in gameData)
    // the following config options are only used in Counting
    customDenominations: null, // set to an object with keys that are coin/dollar data objects, only used if denominationType is set to CUSTOM
    restrictions: { // null for game defaults, otherwise an object containing the restrictions (max number of coins, max number for each coin, max dollar amount)
      maxCoins: 0,
      maxBills: 0,
      maxValue: 0,
      maxPennies: 0,
      maxNickels: 0,
      maxDimes: 0,
      maxQuarters: 0,
      maxOnes: 0,
      maxFives: 0,
      maxTens: 0,
      maxTwenties: 0
    },
    useCents: false, // if true, the values will be displayed in cents instead of dollars and the cent symbol will be used
  };
  if(gameData.gameType==0){
    switch (variantId) {
      // switch on your variant IDs here and set the needed config values
      case "coins-a": // en-US Kindergarten
        config.denominationType = gameData.denominationTypes.COINS;
        config.numOfLevels = 3;
        config.subtitle = "Subtitle_Coins";
      break;
      case "coins-b": // en-US 1st grade
        config.denominationType = gameData.denominationTypes.COINS;
        config.subtitle = "Subtitle_Coins";
      break;
      case "coins-and-dollars-a": // en-US 2nd grade
        config.denominationType = gameData.denominationTypes.COINS_DOLLARS;
        config.subtitle = "Subtitle_CoinsAndDollars";
      break;
    }
  }
  else if(gameData.gameType==1){
    switch (variantId) {
      // switch on your variant IDs here and set the needed config values
      case "counting-pennies-a": // en-US Kindergarten
        config.subtitle = "Pennies";
        config.restrictions.maxPennies = 10;
        config.restrictions.maxCoins = 10;
        config.restrictions.maxValue = 0.1;
        config.useCents = true;
        config.denominationType = gameData.denominationTypes.CUSTOM;
        config.customDenominations = {
          "penny": gameData.coinData.penny
        }
      break;
      case "counting-nickels-a": // en-US kindergarten
      config.subtitle = "Nickels";
      config.restrictions.maxNickels = 10;
      config.restrictions.maxCoins = 10;
      config.restrictions.maxValue = 0.5;
      config.useCents = true;
      config.denominationType = gameData.denominationTypes.CUSTOM;
      config.customDenominations = {
        "nickel": gameData.coinData.nickel
      }
      break;
      case "counting-dimes-a": // en-US kindergarten
      config.subtitle = "Dimes";
      config.restrictions.maxDimes = 9;
      config.restrictions.maxCoins = 9;
      config.restrictions.maxValue = 0.9;
      config.useCents = true;
      config.denominationType = gameData.denominationTypes.CUSTOM;
      config.customDenominations = {
        "dime": gameData.coinData.dime
      }
      break;
      case "counting-mixed-coins-a": // en-US kindergarten
      config.subtitle = "MixedCoins";
      config.restrictions.maxPennies = 5;
      config.restrictions.maxNickels = 4;
      config.restrictions.maxDimes = 2;
      config.restrictions.maxCoins = 5;
      config.restrictions.maxValue = 0.2;
      config.useCents = true;
      config.denominationType = gameData.denominationTypes.CUSTOM;
      config.customDenominations = {
        "penny": gameData.coinData.penny,
        "nickel": gameData.coinData.nickel,
        "dime": gameData.coinData.dime,
      }
      break;
      case "counting-mixed-coins-b": // en-US 1st grade
      config.subtitle = "MixedCoins";
      config.restrictions.maxValue = 0.99;
      config.restrictions.maxPennies = 10;
      config.restrictions.maxNickels = 10;
      config.restrictions.maxDimes = 9;
      config.restrictions.maxQuarters = 3;
      config.restrictions.maxCoins = 10;
      config.useCents = true;
      config.denominationType = gameData.denominationTypes.CUSTOM;
      config.customDenominations = {
        "penny": gameData.coinData.penny,
        "nickel": gameData.coinData.nickel,
        "dime": gameData.coinData.dime,
        "quarter": gameData.coinData.quarter,
      }
      break;
      case "counting-mixed-coins-c": // en-US 2nd grade
      config.subtitle = "MixedCoins";
      config.restrictions.maxCoins = 10;
      config.restrictions.maxValue = 2;
      config.restrictions.maxPennies = 10;
      config.restrictions.maxNickels = 10;
      config.restrictions.maxDimes = 10;
      config.restrictions.maxQuarters = 8;
      config.denominationType = gameData.denominationTypes.CUSTOM;
      config.customDenominations = {
        "penny": gameData.coinData.penny,
        "nickel": gameData.coinData.nickel,
        "dime": gameData.coinData.dime,
        "quarter": gameData.coinData.quarter,
      }
      break;
      case "counting-coins-dollars-a": // en-US 2nd grade
      config.subtitle = "Subtitle_CoinsAndDollars";
      config.restrictions.maxCoins = 10;
      config.restrictions.maxValue = 5;
      config.restrictions.maxPennies = 10;
      config.restrictions.maxNickels = 10;
      config.restrictions.maxDimes = 10;
      config.restrictions.maxQuarters = 10;
      config.restrictions.maxBills = 4;
      config.restrictions.maxOnes = 4;
      config.denominationType = gameData.denominationTypes.CUSTOM;
      config.customDenominations = {
        "penny": gameData.coinData.penny,
        "nickel": gameData.coinData.nickel,
        "dime": gameData.coinData.dime,
        "quarter": gameData.coinData.quarter,
        "1": gameData.dollarData[1],
      }
      break;
      case "counting-mixed-coins-d": // en-US 3rd grade
      config.subtitle = "MixedCoins";
      config.restrictions.maxCoins = 12;
      config.restrictions.maxValue = 3;
      config.restrictions.maxPennies = 10;
      config.restrictions.maxNickels = 10;
      config.restrictions.maxDimes = 10;
      config.restrictions.maxQuarters = 10;
      config.denominationType = gameData.denominationTypes.CUSTOM;
      config.customDenominations = {
        "penny": gameData.coinData.penny,
        "nickel": gameData.coinData.nickel,
        "dime": gameData.coinData.dime,
        "quarter": gameData.coinData.quarter,
      }
      break;
      case "counting-coins-dollars-b": // en-US 3rd grade
      config.subtitle = "Subtitle_CoinsAndDollars";
      config.restrictions.maxCoins = 12;
      config.restrictions.maxValue = 10;
      config.restrictions.maxPennies = 10;
      config.restrictions.maxNickels = 10;
      config.restrictions.maxDimes = 10;
      config.restrictions.maxQuarters = 10;
      config.restrictions.maxBills = 9;
      config.restrictions.maxOnes = 9;
      config.restrictions.maxFives = 1;
      config.denominationType = gameData.denominationTypes.CUSTOM;
      config.customDenominations = {
        "penny": gameData.coinData.penny,
        "nickel": gameData.coinData.nickel,
        "dime": gameData.coinData.dime,
        "quarter": gameData.coinData.quarter,
        "1": gameData.dollarData[1],
        "5": gameData.dollarData[5],
      }
      break;
      case "counting-coins-dollars-c": // en-US 4th grade
      config.subtitle = "Subtitle_CoinsAndDollars";
      config.restrictions.maxCoins = 12;
      config.restrictions.maxValue = 20;
      config.restrictions.maxPennies = 10;
      config.restrictions.maxNickels = 10;
      config.restrictions.maxDimes = 10;
      config.restrictions.maxQuarters = 10;
      config.restrictions.maxBills = 10;
      config.restrictions.maxOnes = 10;
      config.restrictions.maxFives = 3;
      config.restrictions.maxTens = 1;
      config.denominationType = gameData.denominationTypes.CUSTOM;
      config.customDenominations = {
        "penny": gameData.coinData.penny,
        "nickel": gameData.coinData.nickel,
        "dime": gameData.coinData.dime,
        "quarter": gameData.coinData.quarter,
        "1": gameData.dollarData[1],
        "5": gameData.dollarData[5],
        "10": gameData.dollarData[10],
      }
      break;
      default: 
      config.restrictions = null;
      break;
    }
  }
  return config;
}